var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{attrs:{"disabled":!_vm.cuentaSelected || _vm.inactivo || _vm.cerrada},on:{"click":_vm.onSubmit}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-keyboard-f4")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v("Imprimir deuda")]),_vm._v(" "),_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-printer")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }